import { Component, OnInit, ViewChild } from '@angular/core';
import { Account } from '../models/account';
import { User } from '../models/user';
import { AccountService } from '../services/account/account.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { OrderPipe } from 'ngx-order-pipe';
import { UserService } from '../services/user/user.service';
import { Address } from '../models/address';

import { ModalDirective } from 'ngx-bootstrap/modal';
import { ServiceProviderService } from '../services/service-provider/service-provider.service';
import { SidebarComponent } from '../_layout/sidebar/sidebar.component';
import { Router } from '@angular/router';
import { TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Language } from '../models/language';
import { NotificationEvent } from '../models/notificationEvent';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css']
})
export class AccountsComponent implements OnInit {


  @ViewChild(ModalDirective, { static: true }) modal: ModalDirective;
  @ViewChild('template', { static: false }) popUpModal: TemplateRef<any>; // Note: TemplateRef
  @ViewChild('customizationPopup', { static: true }) customizationPopup: ModalDirective;

  listing: boolean = true; rolesAssignedForPayment: string = "";
  confirmPassword: string; userEmailExists: boolean = false; userMobileExists: boolean = false; validateNotificationConfigFlag: boolean = false;
  showPassword: boolean = false; emailExists: boolean = false; mobileExists: boolean = false; nameExists: boolean = false; accountCodeExists: boolean = false;
  viewFieldCustomizationPopup: boolean = false; sidebarComponent: SidebarComponent;
  modalRef: BsModalRef;


  public currentPage: number = 1;
  totalRecords: number = 0;
  
  private searchTerms = new Subject<any[]>();  // Subject to emit search terms
  results: any[] = [];  // Store search results
  // getSerialNumber(indexval) {

  //   return (this.currentPage * 10 - 10) + indexval;
  // }


  public spectacleVendors = []; public readingCenters = []; public serviceProvidersBackup = []; public aiProviders = [];
  public accountInfo: Account = new Account();
  public accounts: Account[];
  public userInfo: User = new User();
  public accountLogo = null;
  public timeZoneList: any[]; public defaultLanguageList: any[] = []; public languageList: any[]; public masterLanguageList: any[]; public selectedMasterLanguageList: any[]; public defaultLanguage;
  public dateFormatList: any[];
  public createdAccountId = null;
  allRoles = [];
  subscriptionType: boolean = false;
  assignedRoles: any = [];
  showPasswordPolicy: Boolean = false;
  isStrongPassword: Boolean = false;
  dropdownSettings: any = {};
  paymentRoledropdownSettings: any = {};
  today: string;
  notificationEvents: NotificationEvent[] = [];
  slotDurations = []

  constructor(public accountService: AccountService, public foruscareService: ForuscareService, public orderPipe: OrderPipe, public userService: UserService, public serviceProviderService: ServiceProviderService, public router: Router, private modalService: BsModalService) {
    this.accounts = orderPipe.transform(this.accounts, 'name');
    this.setupSearch();
  }

  order: string = 'name';
  reverse: boolean = false;
  emailPattern = "";
  rows = 10;
  public paging = {currentPage:  0};

  ngOnInit() {
    this.today = this.foruscareService.getDateForServerAPI(new Date());
    // this.getExistingAccounts(0);
    this.getExistingServiceProviders();
    this.getTimezoneList();
    this.getLanguageList();
    this.allRoles = [{ "id": "1", "itemName": "Account Admin", "role_name": "ROLE_PROGRAM_LEAD" }, { "id": "3", "itemName": "Operator", "role_name": "ROLE_ORGANIZATION" }, { "id": "4", "itemName": "Eye Mitra", "role_name": "ROLE_EYE_MITRA" },{ "id": "5", "itemName": "Eye Connect", "role_name": "ROLE_EYE_CONNECT" }];
    this.dateFormatList = ["dd/MM/yyyy", "dd/MMM/yyyy", "MMM/dd/yyyy", "MM/dd/yyyy", "dd/MM/yyyy hh:mm tt", "MMM/dd/yyyy hh:mm tt", "dd/MMM/yyyy hh:mm tt", "MM/dd/yyyy hh:mm tt", "dd/MM/yyyy H:mm", "dd/MMM/yyyy H:mm", "MM/dd/yyyy H:mm", "MMM/dd/yyyy H:mm",
      "dd-MM-yyyy", "dd-MMM-yyyy", "MMM-dd-yyyy", "MM-dd-yyyy", "dd-MM-yyyy hh:mm tt", "dd-MMM-yyyy hh:mm tt", "MMM-dd-yyyy hh:mm tt", "MM-dd-yyyy hh:mm tt", "dd-MM-yyyy H:mm", "dd-MMM-yyyy H:mm", "MMM-dd-yyyy H:m", "MM-dd-yyyy H:mm",
      "yyyy/dd/MM", "yyyy/dd/MMM", "yyyy/MMM/dd", "yyyy/MM/dd", "yyyy/dd/MM hh:mm tt", "yyyy/MMM/dd hh:mm tt", "yyyy/dd/MMM hh:mm tt", "yyyy/MM/dd hh:mm tt", "yyyy/dd/MM H:mm", "yyyy/dd/MMM H:mm", "yyyy/MM/dd H:mm", "yyyy/MMM/dd H:mm",
      "yyyy-dd-MM", "yyyy-dd-MMM", "yyyy-MMM-dd", "yyyy-MM-dd", "yyyy-dd-MM hh:mm tt", "yyyy-dd-MMM hh:mm tt", "yyyy-MMM-dd hh:mm tt", "yyyy-MM-dd hh:mm tt", "yyyy-dd-MM H:mm", "yyyy-dd-MMM H:mm", "yyyy-MMM-dd H:m", "yyyy-MM-dd H:mm"
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.paymentRoledropdownSettings = {
      singleSelection: false,
      idField: 'role_name',
      textField: 'itemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };

    this.getNotificationEventsList();
    this.fillSlotDurations(1, 60, 1);
  }


  selectstatus(index, value) {

    this.accountInfo.notificationEventList[index].notificationMode = value;
    this.validateNotificationConfig();
  }

  convertUTCToLocal(utcString) {
    return this.foruscareService.convertUTCtoLocal(utcString);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }

  getTimeZone() {
    let timezone = this.timeZoneList.find(ob => ob['offset'] == this.accountInfo.timeZone);
    if (timezone != null)
      return timezone["value"];
  }

  getLanguage() {
    let languageinfo = this.languageList.find(ob => ob['alpha2'] == this.accountInfo.language);
    if (languageinfo != null)
      return languageinfo["English"];
  }

  toggleView() {
    this.listing = !this.listing;
    this.accountInfo = new Account();
    this.accountInfo.notificationEventList = this.notificationEvents; // adding all the notification events list by default for new account creation
    this.confirmPassword = null;
    this.userInfo = new User();
    let offset = new Date().getTimezoneOffset(), o = Math.abs(offset);
    this.accountInfo.timeZone = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    this.accountInfo.language = navigator.language.slice(0, 2);
    this.accountInfo.dateFormat = this.dateFormatList[0];
    if (this.listing) { 
        this.searchData.term = "";
        this.searchData.searchby = "";
      this.getExistingAccounts(0); 
    };
  }

  onStep1Next(event) {

  }

  onStep2Next(event) {

  }

  getExistingServiceProviders() {
    this.spectacleVendors = []; this.readingCenters = []; this.aiProviders = [];
    this.serviceProviderService.getAllExistingProviders()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.serviceProvidersBackup = response.data;
            response.data.forEach(provider => {
              if (provider != null) {
                if (provider.providerType == this.foruscareService.SERVICE_READING_CENTER || provider.providerType == this.foruscareService.SERVICE_TELE_REFRACTION) {
                  this.readingCenters.push({
                    id: provider.providerId,
                    itemName: provider.providerName
                  });
                }
                else if (provider.providerType == this.foruscareService.SERVICE_SPECTACLE) {
                  this.spectacleVendors.push({
                    id: provider.providerId,
                    itemName: provider.providerName
                  });
                }
                else if (provider.providerType == this.foruscareService.SERVICE_AI) {
                  this.aiProviders.push({
                    id: provider.providerId,
                    itemName: provider.providerName
                  });
                }
              }
            });
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  offset: number = 0;
  onPageChange(event) {
    this.offset = event.first;
    this.rows = event.rows;
    this.paging.currentPage = event.first; 
    this.getExistingAccounts(this.offset);
  }

  getExistingAccounts(offset) {
    let count = 10;
    this.accounts = [];
    this.userService.accountSearch(this.searchData.term, this.searchData.searchby, count, this.offset)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            // response.data.forEach(element => {
            //   if (element.logo != null) {
            //     element.logo = element.logo + '?' + new Date().getTime();
            //   }
            // });
            this.accounts = response.data.response;
            this.totalRecords = response.data.totalCount;
            //get base64 data for logo
            this.accounts.forEach(element => {
              if (element.logo != null && element.logo.indexOf("blob.core.windows.net") > -1) {
                this.serviceProviderService.getBlobURLtobase64(element.logo)
                  .subscribe(response => {
                    if (response != null && response.errorCode == 200) {
                      element.logo = "data:image/jpg;base64," + response.data;
                    }
                  });
              }
            });
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getTimezoneList() {
    this.timeZoneList = [];
    this.accountService.getTimeZoneList()
      .subscribe(response => {
        if (response != null && response.length > 0) {
          this.timeZoneList = response;
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getLanguageList() {
    this.languageList = [];
    this.masterLanguageList = [];
    this.accountService.getLanguagesList()
      .subscribe(response => {
        if (response.data != null && response.data.length > 0) {
          this.languageList = response.data;
          response.data.forEach(element => {
            this.masterLanguageList.push({ id: element.languageCode, itemName: element.language + " - " + element.description });
          });
          this.masterLanguageList.sort(function (a, b) {
            if (a.itemName.split(" - ")[1] > b.itemName.split(" - ")[1]) { return 1; }
            else if (a.itemName.split(" - ")[1] < b.itemName.split(" - ")[1]) { return -1; }
            return 0;
          });
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }


  editAccountInfo(accountInfo: Account) {
    if (accountInfo != null) {
      let providerIds = accountInfo.providerIds;
      accountInfo.providerIds = []; accountInfo.spectacleVendors = []; accountInfo.readingCenters = []; accountInfo.aiProviders = [];
      if (providerIds != null && providerIds.length > 0 && this.serviceProvidersBackup != null && this.serviceProvidersBackup.length > 0) {
        providerIds.forEach(providerId => {
          this.serviceProvidersBackup.forEach(providerInfo => {
            if (providerId == providerInfo.providerId) {
              if (providerInfo.providerType == this.foruscareService.SERVICE_SPECTACLE) {
                accountInfo.spectacleVendors.push({
                  id: providerInfo.providerId,
                  itemName: providerInfo.providerName
                });
              }
              else if (providerInfo.providerType == this.foruscareService.SERVICE_READING_CENTER || providerInfo.providerType == this.foruscareService.SERVICE_TELE_REFRACTION) {
                accountInfo.readingCenters.push({
                  id: providerInfo.providerId,
                  itemName: providerInfo.providerName
                });
              }
              else if (providerInfo.providerType == this.foruscareService.SERVICE_AI) {
                accountInfo.aiProviders.push({
                  id: providerInfo.providerId,
                  itemName: providerInfo.providerName
                });
              }
            }
          })
        })
      }
      if (accountInfo.subscriptionType != null) {
        if (accountInfo.subscriptionType.toUpperCase() == "PREPAID") {
          this.subscriptionType = false;
        }
        else if (accountInfo.subscriptionType.toUpperCase() == "POSTPAID") {
          this.subscriptionType = true;
        }
      }

      if (accountInfo.rolesForPayment != null && accountInfo.rolesForPayment.length > 0) {
        this.assignedRoles = [];
        var tempRoles = [];
        this.rolesAssignedForPayment = accountInfo.rolesForPayment;
        tempRoles = accountInfo.rolesForPayment.split(",");
        for (var i = 0; i < tempRoles.length; i++) {
          if (tempRoles[i] == 'ROLE_ORGANIZATION')
            this.assignedRoles.push({ "id": i, "itemName": "Operator", "role_name": tempRoles[i] });
          if (tempRoles[i] == 'ROLE_PROGRAM_LEAD')
            this.assignedRoles.push({ "id": i, "itemName": "Account Admin", "role_name": tempRoles[i] });
          if (tempRoles[i] == 'ROLE_EYE_MITRA')
            this.assignedRoles.push({ "id": i, "itemName": "Eye Mitra", "role_name": tempRoles[i] });
          if (tempRoles[i] == 'ROLE_EYE_CONNECT')
            this.assignedRoles.push({ "id": i, "itemName": "Eye Connect", "role_name": tempRoles[i] });
        }

      }
      else {
        this.assignedRoles = [];
      }
      // if (accountInfo.timeZone != null) {
      //   if (!isNaN(parseFloat(accountInfo.timeZone))) {
      //     accountInfo.timeZone = parseFloat(accountInfo.timeZone);
      //   }
      // }

      this.selectedMasterLanguageList = [];
      this.defaultLanguageList = [];
      this.defaultLanguage = null;
      if (accountInfo.languageList != null && accountInfo.languageList.length > 0) {
        accountInfo.languageList.forEach(language => {
          this.selectedMasterLanguageList.push({ id: language.languageCode, itemName: language.language + " - " + language.description });
          this.defaultLanguageList = this.selectedMasterLanguageList;
          if (language.isDefault) {
            this.defaultLanguage = language.languageCode;
          }
        });
      }
      /*adding notification events in account object */
      if (accountInfo.notificationEventList && accountInfo.notificationEventList.length > 0) {
        let tempList = JSON.parse(JSON.stringify(this.notificationEvents));
        tempList.forEach(event1 => {
          let foundInAccountObj = false;
          accountInfo.notificationEventList.forEach(event2 => {
            if (event1.id == event2.id) {
              foundInAccountObj = true;
              event1.smsEnabled = event2.smsEnabled;
              event1.emailEnabled = event2.emailEnabled;
              event1.whatsappEnabled = event2.whatsappEnabled;
              event1.notificationMode = event2.notificationMode;
            }
          });
          if (!foundInAccountObj) {
            event1.accountId = accountInfo.id;
            accountInfo.notificationEventList.push(event1);
          }
        });
        accountInfo.notificationEventList = tempList;
      }
      else {
        accountInfo.notificationEventList = [];
        this.notificationEvents.forEach(event => {
          event.accountId = accountInfo.id;
          accountInfo.notificationEventList.push(event);
        });
      }
      this.accountInfo = accountInfo;
      this.listing = false;

    }
  }

  getAddressString(address: Address): string {
    return this.foruscareService.getAddressString(address);
  }

  getUserRoleName(key: string) {
    //console.log(key);
    if (key != null) {
      return this.foruscareService.getUserRolesArrayToString(key);
    }
  }

  userEmailValidationService = null; userMobileValidationService = null;
  validateUserEmailExists(accountInfoForm) {
    if (accountInfoForm != null && accountInfoForm.form != null && accountInfoForm.form.controls != null && accountInfoForm.form.controls.userEmail != null && accountInfoForm.form.controls.userEmail.status == "INVALID")
      return;
    if (this.userEmailValidationService != null) {
      this.userEmailValidationService.unsubscribe();
    }
    this.userEmailValidationService = this.userService.checkEmailExists(this.userInfo.email)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.userEmailExists) {
            this.userEmailExists = true;
          }
          else this.userEmailExists = false;
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  previousWizardClick() {
    this.validateNotificationConfigFlag = false;
  }
  validateNotificationConfig(): boolean {
    let isvalidcofig: boolean = true;
    if (this.accountInfo != null && this.accountInfo.notificationEventList != null) {

      this.accountInfo.notificationEventList.forEach(element => {

        if ((element.smsEnabled == true || element.emailEnabled == true || element.whatsappEnabled == true) && (element.notificationMode == null)) {

          this.foruscareService.showNotification("Please select the Mode", "danger");
          isvalidcofig = false;
        }
        if ((element.smsEnabled == false && element.emailEnabled == false && element.whatsappEnabled == false) && (element.notificationMode != null)) {

          element.notificationMode = null;
        }

      });

    } else {
      //this.validateNotificationConfigFlag = true;
      isvalidcofig = true;
    }
    if (isvalidcofig) {
      this.validateNotificationConfigFlag = true;
      console.log(this.validateNotificationConfigFlag);
      return true;
    } else {

      this.validateNotificationConfigFlag = false;
      console.log(this.validateNotificationConfigFlag);
      return false;

    }

  }



  validateUserMobileExists() {
    if (this.userInfo != null && this.userInfo.phoneNo != null && this.userInfo.phoneNo.trim().length < 10)
      return;
    if (this.userMobileValidationService != null) {
      this.userMobileValidationService.unsubscribe();
    }
    this.userMobileValidationService = this.userService.checkMobileExists(this.userInfo.phoneNo)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null && response.data.userPhoneNumberExists) {
            this.userMobileExists = true;
          }
          else this.userMobileExists = false;
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  paymentRolesUpdate(event) {
    this.rolesAssignedForPayment = '';
    if (event != null && event.length > 0) {
      for (var i = 0; i < event.length; i++) {
        if (i == event.length - 1) {
          this.rolesAssignedForPayment = this.rolesAssignedForPayment + event[i].role_name;
        }
        else {
          this.rolesAssignedForPayment = this.rolesAssignedForPayment + event[i].role_name + ',';
        }
      }
    }
    else {
      this.assignedRoles = null;
    }
  }

  validateAccountInfo(fieldToValidate: string) {
    if (fieldToValidate == "email") {
      if (this.accountInfo.email != null) {
        this.accountInfo.email = this.accountInfo.email.trim();
        let data = this.accounts.filter(ob => ob['email'].toLowerCase() === this.accountInfo.email.toLowerCase());
        if (data != null) {
          if ((this.accountInfo.id != null && data.length > 1) || (this.accountInfo.id == null && data.length > 0)) {
            this.foruscareService.showNotification("Account email already exists.", "warning");
            this.emailExists = true;
            return;
          }
          else {
            this.emailExists = false;
          }
        }
        else
          this.emailExists = false;
      }
    }
    else if (fieldToValidate == "mobile") {
      if (this.accountInfo.mobile != null) {
        this.accountInfo.mobile = this.accountInfo.mobile.trim();
        let data = this.accounts.filter(ob => ob['mobile'].toLowerCase() === this.accountInfo.mobile.toLowerCase());
        if (data != null) {
          if ((this.accountInfo.id != null && data.length > 1) || (this.accountInfo.id == null && data.length > 0)) {
            this.foruscareService.showNotification("Account mobile already exists.", "warning");
            this.mobileExists = true;
            return;
          }
          else {
            this.mobileExists = false;
          }
        }
        else
          this.mobileExists = false;
      }
    }
    else if (fieldToValidate == "name") {
      if (this.accountInfo.name != null) {
        // this.accountInfo.name = this.accountInfo.name.trim();
        let data = this.accounts.filter(ob => ob['name'].toLowerCase() == this.accountInfo.name.trim().toLowerCase());
        if (data != null) {
          if ((this.accountInfo.id != null && data.length > 1) || (this.accountInfo.id == null && data.length > 0)) {
            this.foruscareService.showNotification("Account name already exists.", "warning");
            this.nameExists = true;
            return;
          }
          else {
            this.nameExists = false;
          }
        }
        else
          this.nameExists = false;
      }
    }
    else if (fieldToValidate == "code") {
      if (this.accountInfo.accountCode != null) {
        // this.accountInfo.name = this.accountInfo.name.trim();
        let data = this.accounts.filter(ob => ob['accountCode'] == null ? "" : ob['accountCode'].toLowerCase() == this.accountInfo.accountCode.trim().toLowerCase());
        if (data != null) {
          if ((this.accountInfo.id != null && data.length > 1) || (this.accountInfo.id == null && data.length > 0)) {
            this.foruscareService.showNotification("Account code already exists.", "warning");
            this.accountCodeExists = true;
            return;
          }
          else {
            this.accountCodeExists = false;
          }
        }
        else
          this.accountCodeExists = false;
      }
    }
  }

  defaultLogo = '/assets/images/no-logo.png';
  setDefaultLogo(event: Event) {
  const img = event.target as HTMLImageElement;
  img.src = this.defaultLogo;
  }

  updateAccountLogo(accountInfo: Account) {
    if (accountInfo != null) {
      this.accountInfo = accountInfo;
      this.showModal();
    }
  }

  showModal() {
    this.modal.show();
  }
  closeModal() {
    this.modal.hide();
    // this.insertDefaultFields(); //to show the field customization pop up
  }

  closeLogoUpload() {
    this.closeModal();
    if (!this.listing) {
      this.toggleView();
    }
    if (this.createdAccountId != null) {
      this.customizationPopup.show(); // to show the customization pop up
    }
  }

  imagePathToUpload = null;

  onFileChanged(event) {
    this.accountLogo = event.target.files[0];
    var oFReader = new FileReader();
    oFReader.readAsDataURL(event.target.files[0]);

    oFReader.onload = function (oFREvent) {
      document.getElementById("uploadPreview")["src"] = oFREvent.target["result"];
    };
  }

  uploadFile() {
    this.closeModal();
    // this.http is the injected HttpClient
    const uploadData = new FormData();
    uploadData.append("file", this.accountLogo);
    // uploadData.append("filename", this.accountLogo.name)
    // uploadData.append("accountId", this.userInfo.accountId.toString());
    this.accountService.uploadAccountLogo(uploadData, this.accountInfo.id)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.foruscareService.showNotification("Account logo uploaded successfully.", "success");
            this.accountLogo = null;
            document.getElementById("fileuploader")["value"] = "";
            //update logo in the selected account
            if (response.data.logo != null && response.data.logo.indexOf("blob.core.windows.net") > -1) {
              this.serviceProviderService.getBlobURLtobase64(response.data.logo)
                .subscribe(response2 => {
                  if (response2 != null && response2.errorCode == 200) {
                    this.accountInfo.logo = "data:image/jpg;base64," + response2.data;
                  }
                });
            }
            this.closeModal();
            if (!this.listing) {
              this.toggleView();
            }
            else {
              this.getExistingAccounts(0);
            }
          }
          if (this.createdAccountId != null) {
            this.customizationPopup.show(); // to show the customization pop up
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  insertDefaultFields() {
    //console.log(this.accountInfo);

    var defaultFields = {
      "id": null, "accountId": this.accountInfo.id,
      "customFields":
        [
          { "id": null, "accountId": this.accountInfo.id, "fieldName": "Name", "fieldType": "Text Box", "isMandatory": true, "regex": "", "minLength": null, "maxLength": null, "fieldOrder": 1, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Patient", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": true, "deviceType": null, "fieldIdentity": "NAME" },
          { "id": null, "accountId": this.accountInfo.id, "fieldName": "Gender", "fieldType": "Drop Down", "isMandatory": true, "regex": "", "minLength": null, "maxLength": null, "fieldOrder": 2, "fieldOptions": "Male,Female,Transgender", "sectionId": null, "isSearchable": false, "module": "Patient", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": true, "deviceType": null, "fieldIdentity": "GENDER" },
          { "id": null, "accountId": this.accountInfo.id, "fieldName": "Age", "fieldType": "Number", "isMandatory": false, "regex": "", "minLength": null, "maxLength": null, "fieldOrder": 3, "fieldOptions": "Male,Female,Transgender", "sectionId": null, "isSearchable": false, "module": "Patient", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": true, "deviceType": null, "fieldIdentity": "AGE" },
          { "id": null, "accountId": this.accountInfo.id, "fieldName": "Mobile", "fieldType": "Number", "isMandatory": true, "regex": "", "minLength": null, "maxLength": null, "fieldOrder": 4, "fieldOptions": "Male,Female,Transgender", "sectionId": null, "isSearchable": false, "module": "Patient", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": true, "deviceType": null, "fieldIdentity": "MOBILE" },
          { "id": null, "accountId": this.accountInfo.id, "fieldName": "Email", "fieldType": "Text Box", "isMandatory": false, "regex": "", "minLength": null, "maxLength": null, "fieldOrder": 5, "fieldOptions": "Male,Female,Transgender", "sectionId": null, "isSearchable": false, "module": "Patient", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": true, "deviceType": null, "fieldIdentity": "EMAIL" },
          { "id": null, "accountId": this.accountInfo.id, "fieldName": "Address", "fieldType": "Text Box", "isMandatory": false, "regex": "", "minLength": null, "maxLength": null, "fieldOrder": 6, "fieldOptions": "Male,Female,Transgender", "sectionId": null, "isSearchable": false, "module": "Patient", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": true, "deviceType": null, "fieldIdentity": "NONE" }
        ],
      "sections": [{
        "id": null, "accountId": this.accountInfo.id, "sectionName": "Symptoms", "sectionOrder": 1, "customFields": [{ "id": null, "accountId": this.accountInfo.id, "fieldName": "Defective Vision", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 1, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Trauma", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 2, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Sudden Loss Of Vision", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 2, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Pain", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 3, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Watering", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 4, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Discharge", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 5, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Headache", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 6, "fieldOptions": "Yes,No", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" }
        ], "status": true, "created": null, "lastUpdated": null, "module": "Medical Info", "deviceType": null
      },
      {
        "id": null, "accountId": this.accountInfo.id, "sectionName": "Ocular History", "sectionOrder": 2, "customFields": [{ "id": null, "accountId": this.accountInfo.id, "fieldName": "Cataract Surgery", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 1, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Glaucoma Surgery", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 2, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Lasers or Any Retina Surgeries", "fieldType": "Check Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 3, "fieldOptions": "Left Eye,Right Eye", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Wearing Glasses Now", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 4, "fieldOptions": "Yes,No", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Any Other Ocular Surgeries", "fieldType": "Text Area", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 5, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Right IOP", "fieldType": "Text Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 6, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Left IOP", "fieldType": "Text Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 7, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" }
        ], "status": true, "created": null, "lastUpdated": null, "module": "Medical Info", "deviceType": null
      },
      {
        "id": null, "accountId": this.accountInfo.id, "sectionName": "Ocular Examination", "sectionOrder": 3, "customFields": [{ "id": null, "accountId": this.accountInfo.id, "fieldName": "Right Eye Cataract", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 1, "fieldOptions": "Present,Absent", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Left Eye Cataract", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 2, "fieldOptions": "Present,Absent", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Right Eye Corneal Opacity", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 3, "fieldOptions": "Present,Absent", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Left Eye Corneal Opacity", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 4, "fieldOptions": "Present,Absent", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Any Trauma/Foreign Body (Right Eye)", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 5, "fieldOptions": "Present,Absent", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Any Trauma/Foreign Body (Left Eye)", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 6, "fieldOptions": "Present,Absent", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" }
        ], "status": true, "created": null, "lastUpdated": null, "module": "Medical Info", "deviceType": null
      },
      {
        "id": null, "accountId": this.accountInfo.id, "sectionName": "Visual Acuity - Before Refraction", "sectionOrder": 4, "customFields": [{ "id": null, "accountId": this.accountInfo.id, "fieldName": "Right Eye", "fieldType": "Drop Down", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 1, "fieldOptions": "6/60,6/36,6/24,6/18,6/12,6/9,6/6,6/5", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Left Eye", "fieldType": "Drop Down", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 2, "fieldOptions": "6/60,6/36,6/24,6/18,6/12,6/9,6/6,6/5", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" }
        ], "status": true, "created": null, "lastUpdated": null, "module": "Medical Info", "deviceType": null
      },
      {
        "id": null, "accountId": this.accountInfo.id, "sectionName": "Clinical History", "sectionOrder": 5, "customFields": [{ "id": null, "accountId": this.accountInfo.id, "fieldName": "Diabetes Mellitus", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 1, "fieldOptions": "Present,Absent,Don't Know", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Hypertension", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 2, "fieldOptions": "Present,Absent,Don't Know", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Heart Disease", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 3, "fieldOptions": "Present,Absent,Don't Know", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Cancer", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 4, "fieldOptions": "Present,Absent,Don't Know", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Head Injury", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 5, "fieldOptions": "Yes,No", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Is Single Eyed ?", "fieldType": "Radio Button", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 6, "fieldOptions": "Yes,No", "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Other Disease (Father)", "fieldType": "Text Area", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 7, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Other Disease (Mother)", "fieldType": "Text Area", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 8, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Other Disease (Siblings)", "fieldType": "Text Area", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 9, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" }
        ], "status": true, "created": null, "lastUpdated": null, "module": "Medical Info", "deviceType": null
      },
      {
        "id": null, "accountId": this.accountInfo.id, "sectionName": "Physical Details", "sectionOrder": 6, "customFields": [{ "id": null, "accountId": this.accountInfo.id, "fieldName": "Height", "fieldType": "Text Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 1, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" },
        { "id": null, "accountId": this.accountInfo.id, "fieldName": "Weight", "fieldType": "Text Box", "isMandatory": false, "regex": null, "minLength": null, "maxLength": null, "fieldOrder": 2, "fieldOptions": null, "sectionId": null, "isSearchable": false, "module": "Medical Info", "status": true, "created": null, "lastUpdated": null, "fieldValue": null, "patientId": null, "isConfidential": false, "deviceType": null, "fieldIdentity": "NONE" }
        ], "status": true, "created": null, "lastUpdated": null, "module": "Medical Info", "deviceType": null
      }
      ]
    };

    this.accountService.insertDefaultFields(this.accountInfo.id, defaultFields)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.createdAccountId = this.accountInfo.id;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }
  closeCustomFieldPopUp() {
    this.customizationPopup.hide();
  }

  onComplete(event) {

    if (this.accountInfo == null)
      return;

    let serviceProviders = [];

    if (!this.accountInfo.isAIEnabled) {
      this.accountInfo.aiProviders = [];
    }
    if (!this.accountInfo.isTrial) {
      // this.accountInfo.trialDuration = null;
    }
    if (this.accountInfo.readingCenters != null && this.accountInfo.readingCenters.length > 0) {
      this.accountInfo.readingCenters.forEach(provider => {
        this.accountInfo.providerIds.push(provider.id);
      })
    }
    if (this.accountInfo.spectacleVendors != null && this.accountInfo.spectacleVendors.length > 0) {
      this.accountInfo.spectacleVendors.forEach(provider => {
        this.accountInfo.providerIds.push(provider.id);
      })
    }
    if (this.accountInfo.aiProviders != null && this.accountInfo.aiProviders.length > 0) {
      this.accountInfo.aiProviders.forEach(provider => {
        this.accountInfo.providerIds.push(provider.id);
      })
    }
    this.accountInfo.languageList = [];
    if (this.selectedMasterLanguageList != null && this.selectedMasterLanguageList.length > 0) {
      if (!this.defaultLanguage) {
        this.foruscareService.showNotification("Please select default language.", "danger");
        return;
      }
      this.languageList.forEach(allLanguage => {
        let temp: Language = allLanguage;
        this.selectedMasterLanguageList.forEach(selectedMasterLanguage => {
          if (allLanguage.languageCode == selectedMasterLanguage.id) {
            temp.isDefault = (selectedMasterLanguage.id == this.defaultLanguage) ? true : false;
            if (this.accountInfo.id != null) {
              temp.accountId = this.accountInfo.id;
            }
            this.accountInfo.languageList.push(temp);
          }
        });
      });
    }
    else {
      this.foruscareService.showNotification("Please select language.", "danger");
      return;
    }
    if (this.assignedRoles != null && this.assignedRoles.length > 0) {
      var tempAssignedRoles = '';
      for (var i = 0; i < this.assignedRoles.length; i++) {
        if (i == this.assignedRoles.length - 1) {
          tempAssignedRoles = tempAssignedRoles + this.assignedRoles[i].role_name;
        }
        else {
          tempAssignedRoles = tempAssignedRoles + this.assignedRoles[i].role_name + ',';
        }
      }
      this.accountInfo.rolesForPayment = tempAssignedRoles;
    }
    else {
      this.accountInfo.rolesForPayment = null;
    }
    delete this.accountInfo["spectacleVendors"];
    delete this.accountInfo["readingCenters"];
    delete this.accountInfo["aiProviders"];

    if (this.subscriptionType) {
      this.accountInfo.subscriptionType = 'POSTPAID';
    }
    else {
      this.accountInfo.subscriptionType = 'PREPAID';
    }

    if (this.accountInfo.id != null) {
      this.accountService.updateAccount(this.accountInfo)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.foruscareService.showNotification("Account info updated successfully.", "success");
              this.toggleView();
            }
          } else if (response.errorCode == 409) {
            this.foruscareService.showNotification("Cannot change slot duration while appointments are booked for this screening event. Please wait until the event is complete.", "danger");
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    } else {
      this.accountInfo.name = this.accountInfo.name.trim();
      this.accountService.createAccount(this.accountInfo)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.foruscareService.showNotification("Account created successfully.", "success");
              this.accountInfo = response.data;
              this.userInfo.accountId = response.data.id;
              this.userInfo.canDoPayment = true;
              this.insertDefaultFields(); //to show the field customization pop up
              this.userService.createUser(this.userInfo)
                .subscribe(response => {
                  if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
                    if (response.data != null) {
                      this.foruscareService.showNotification("Admin user created successfully.", "success");
                      this.showModal();
                    }
                  }
                  else {
                    this.foruscareService.showNotification(response.message, "danger");
                  }
                });
            }
            else {
              this.foruscareService.showNotification("Account info updated successfully.", "success");
              this.toggleView();
            }
          }
          else {
            if (response.errorCode == 409) {
              this.foruscareService.showNotification("Account name already exists.", "danger");
            }
            else {
              this.foruscareService.showNotification(response.message, "danger");
            }
          }
        });
    }
  }

  _keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  addNewAccount() {
    // this.accountInfo = new Account();
    // this.confirmPassword = null;
    // this.userInfo = new User();
    this.showPasswordPolicy = false;
    this.isStrongPassword = false;
    this.showModal();
  }

  navigateToTemplate(event, path) {
    if (event.target.parentElement.parentElement.parentElement.classList.contains("menulist")) {
      event.target.parentElement.classList.add("active");
      return;
    }
    let elements = document.querySelectorAll('.navlink');
    if (elements != null && elements.length > 0) {
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].parentElement != event.target.parentElement.parentElement)
          while (elements[i].parentElement.classList.contains("active")) {
            elements[i].parentElement.classList.remove("active");
          }
      }
    }
    if (!event.target.parentElement.classList.contains("active")) {
      event.target.parentElement.classList.add("active");
    }
    else {
      event.target.parentElement.classList.remove("active");
    }
    this.router.navigate([path]);
  }
  clearAccountValidityDate() {
    this.accountInfo.accountValidityDate = null;
  }
  languageModified(obj, action) {
    this.defaultLanguage = null;
    switch (action) {
      case "ADD":
        this.defaultLanguageList.push(obj);
        break;
      case "REMOVE":
        for (var i = 0; i < this.defaultLanguageList.length; i++) {
          if (obj.id == this.defaultLanguageList[i].id) {
            this.defaultLanguageList.splice(i, 1);
            break;
          }
        }
        break;
      case "ADD_ALL":
        this.defaultLanguageList = obj;
        break;
      case "REMOVE_ALL":
        this.defaultLanguageList.splice(0);
        break;

    }
    if (this.defaultLanguageList != null && this.defaultLanguageList.length > 0) {
      this.defaultLanguageList.sort(function (a, b) {
        if (a.itemName.split(" - ")[1] > b.itemName.split(" - ")[1]) { return 1; }
        else if (a.itemName.split(" - ")[1] < b.itemName.split(" - ")[1]) { return -1; }
        return 0;
      });
      //this.defaultLanguage = this.defaultLanguageList[0].id;
    }
  }

  getNotificationEventsList() {
    this.notificationEvents = [];
    this.accountService.getNotificationEventList()
      .subscribe((response) => {
        if (response.errorCode == 200 && response.data != null) {
          response.data.forEach(element => {
            let notificationEvent = new NotificationEvent();
            notificationEvent.id = element.id;
            notificationEvent.code = element.code;
            notificationEvent.label = element.label;
            notificationEvent.sms = element.sms;
            notificationEvent.email = element.email;
            notificationEvent.notificationMode = element.notificationMode;
            notificationEvent.whatsapp = element.whatsapp;
            this.notificationEvents.push(notificationEvent);
          });
          console.log("this.notificationEvents", this.notificationEvents);
        }
        else {
          this.foruscareService.showNotification('Something went wrong', "danger");
        }
      });
  }
  /*start : check strong password */
  checkStrongPassword(password) {
    return this.foruscareService.verifyPasswordStrength(password);
  }
  /*end : check strong password */

  // For Slot Duartions function
  fillSlotDurations(start: number, end: number, difference: number) {
    for (let i = start; i <= end; i = i + difference) {
      this.slotDurations.push({ id: i.toString(), name: i });
    }
  }

  setupSearch(): void {
    let count = 10;
    this.accounts = [];
    this.searchTerms.pipe(
      debounceTime(300),                // Wait for 300ms after the user stops typing
      distinctUntilChanged(),           // Only call the API if the term has changed
      switchMap((term: any) => this.userService.accountSearch(term[0],term[1], count, this.offset))  // Switch to the new search term
    ).subscribe(response => {
        if (response.data != null && response.data.response.length > 0) {
          this.accounts = response.data.response;
          this.totalRecords = response.data.totalCount;
          this.accounts.forEach(element => {
            if (element.logo != null && element.logo.indexOf("blob.core.windows.net") > -1) {
              this.serviceProviderService.getBlobURLtobase64(element.logo)
                .subscribe(response => {
                  if (response != null && response.errorCode == 200) {
                    element.logo = "data:image/jpg;base64," + response.data;
                  }
                });
            }
          });
        }else{
          this.accounts = [];
        }
            // Update the results after the API call
    });
  }
  searchData = {
    term:'',
    searchby:''
  }
  // Method triggered when typing in the search box
  onSearch(term: string, searchby:string): void {
    this.offset = 0;
    this.accounts = [];
    this.paging.currentPage = 0;
    // Encode the searchBy value to handle special characters like &
    const encodedSearchBy = encodeURIComponent(term);
    this.searchTerms.next([encodedSearchBy,searchby]);  // Push the search term into the observable stream
    if(encodedSearchBy.length > 0){
      this.searchData = {
        term:encodedSearchBy,
        searchby:searchby
      }
    }
    else{
      this.searchData = {
        term:null,
        searchby:null
      }
    }
  }

}
